export enum UIThemeEnum {
  dark = 'dark',
  light = 'light',
}


export type colorSet =  'primary' | 'info' | 'success' | 'warning' | 'light' | string;